import { css } from '@nfront/global-styles';
import googleFonts from '../static/fonts';

const globalStyles = css`
  ${googleFonts}
  * {
    box-sizing: border-box;
  }
  html {
    -webkit-font-smoothing: antialiased;
    height: 100%;
  }
  body {
    margin: 0;
    max-height: 100%;
    height: 100%;
    font-family: Lato, sans-serif;
  }
  #___gatsby,
  #gatsby-focus-wrapper {
    height: 100%;
  }
  #gatsby-announcer {
    top: 0; // TODO: Remove after upgrading gatsby
  }
  img {
    max-width: 100%;
  }
  ul {
    margin: 0 0 1.75rem;
    padding: 0 0 0 1.25rem;
    list-style-position: outside;
    list-style-image: none;
  }
  li {
    margin-bottom: 0.25rem;
    font-size: 1.125rem;
    line-height: 1.5;
  }
  ol {
    margin: 0 0 1.75rem;
    padding: 0 0 0 1.25rem;
    list-style-position: outside;
    list-style-image: none;
  }
  figure {
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    margin-bottom: 1.45rem;
  }
  p {
    margin-left: 0;
    margin-right: 0;
    margin-top: 0;
    padding-bottom: 0;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    font-size: 1.125rem;
    line-height: 1.5;
    margin-bottom: 1.75rem;
  }

  .footnotes p {
    margin-block-end: 0;
  }
  .inputContainer {
    width: 100%;
  }
  input + label.btn {
    font-size: 0.9rem;
  }
  a {
    color: #1bb0db;
    text-decoration: none;
  }
  a:hover,
  a:focus {
    text-decoration: underline;
    outline: none;
  }
  iframe {
    margin-bottom: 2rem;
  }
  h2::before {
  display: block; 
  content: " "; 
  margin-top: -5rem; 
  height: 5rem; 
  visibility: hidden; 
  pointer-events: none;
  }
  `;

export default globalStyles;
